import { render, staticRenderFns } from "./course-cleanKeeping.vue?vue&type=template&id=24c50c06&scoped=true&"
import script from "./course-cleanKeeping.vue?vue&type=script&lang=js&"
export * from "./course-cleanKeeping.vue?vue&type=script&lang=js&"
import style0 from "./course-cleanKeeping.vue?vue&type=style&index=0&id=24c50c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c50c06",
  null
  
)

export default component.exports